import styled from 'styled-components';
import Icon from 'assets/about-app.svg';

export const Container = styled.div`
  background-image: url('${Icon}');
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 40px auto;

  padding: 45px 0.15em 0 0;
  min-width: 50px;
  width: 50px;
`;

export const Version = styled.div`
  font-size: ${(p) => p.theme.fontSmaller};
  text-align: end;
  opacity: 0.5;
`;
